import React, { useCallback } from 'react';
import { isNull } from 'lodash/fp';

import { useAppDispatch, useAppSelector } from '../../../../hooks/react-redux';
import { SingleField } from '../fields/SingleField';
import { getOpenFieldsAndSections, toggleOpenFieldSection } from '../store';
import { IndependentAmountProvisions, UpdatedOpinionField } from '../store/types';
import styles from './OpinionSection.module.scss';
import { SectionWrapper } from './SectionWrapper';

interface IndependentAmountProvisionsProps {
    independentAmount: IndependentAmountProvisions;
    previousIndependentAmount: IndependentAmountProvisions | null;
    isEditing: boolean;
    isUpdating: boolean;
    fieldsUpdated: UpdatedOpinionField[];
}

export const IndependentAmountSection: React.FC<IndependentAmountProvisionsProps> = ({ independentAmount, previousIndependentAmount, isEditing, isUpdating, fieldsUpdated }) => {
    const dispatch = useAppDispatch();
    const openFieldsAndSections = useAppSelector(getOpenFieldsAndSections);
    const getFieldOpen = useCallback((id: string) => openFieldsAndSections.includes(id), [openFieldsAndSections]);
    const toggleFieldOpen = useCallback((id: string) => dispatch(toggleOpenFieldSection(id)), [dispatch]);
    const sectionId = 'independentAmount';
    const { independentAmountProvisions } = independentAmount;

    const getPreviousField = useCallback((fieldId: keyof IndependentAmountProvisions) => !isNull(previousIndependentAmount) && previousIndependentAmount[fieldId] || null, [previousIndependentAmount]);

    return (
        <SectionWrapper id={sectionId} label='Independent Amount (IA) Provisions' isEditing={isEditing} isUpdating={isUpdating}>
            <div className={styles.protocolsSectionWrapper}>
                <div className={styles.sectionHeaderLabel}>Under the laws of the jurisdiction under consideration:</div>
                <SingleField
                    field={independentAmountProvisions}
                    previousField={getPreviousField('independentAmountProvisions')}
                    fieldId='independentAmountProvisions'
                    sectionId={sectionId}
                    isEditing={isEditing}
                    isUpdating={isUpdating}
                    fieldsUpdated={fieldsUpdated}
                    getFieldOpen={getFieldOpen}
                    toggleFieldOpen={toggleFieldOpen}
                    positiveAnswers={['No']}
                    negativeAnswers={['Yes', 'Yes - with exceptions']}
                />
            </div>
        </SectionWrapper>
    );
};
